<!-- <ion-footer mode="ios"> -->
  <div class="chat-footer-container bg-white">
    <div class="bg-white flex justify-center pt-1 px-2">
      <div class="flex bg-[#F5FAFD] w-full rounded-[10px]">
        <ion-button
          mode="ios"
          fill="clear"
          size="small"
          (click)="onSelectImage()"
          [disabled]="disabled || sending"
        >
          <ion-icon
            src="../../../../assets/svg/camera.svg"
            class="text-2xl"
          ></ion-icon>
        </ion-button>
        <div class="w-full flex items-end px-2 pb-1">
          <ion-textarea
            [value]="message"
            (ionInput)="onMessageChange($event)"
            (keydown)="onKeyDown($event)"
            placeholder="{{ 'FORM_INPUTS.ATTRIBUTES.PLACEHOLDER' | translate }}"
            rows="1"
            class="text-[12px] mb-[-2px]"
            auto-grow="true"
            mode="ios"
            [disabled]="disabled"
          ></ion-textarea>
        </div>
        <ion-button
          fill="clear"
          mode="ios"
          size="small"
          (mousedown)="$event.preventDefault()"
          (click)="onSendMessage()"
          [disabled]="disabled || sending || !message.trim()"
        >
          <ion-icon
            src="../../../../assets/svg/arrorRight2.svg"
            class="text-[15px]"
            color="secondary"
          ></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>
<!-- </ion-footer> -->
